// extracted by mini-css-extract-plugin
export default {"tumbleweed":"#dab177","content":"Bi","header":"Bj","image":"Bk","link":"Bl","link-wrapper":"Bm","linkWrapper":"Bm","reagents":"Bn"};